import { SentryError } from '@ifixit/sentry';

export const getFormParent = (el: Element): Element => {
   const form = el.closest('form');
   if (form === null) {
      throw new SentryError('No form parent found');
   }
   return form;
};
